import { useCallback, useEffect, useState } from 'react';
import { fetchLegalDocument } from '../api/legal';

function formatUpdatedAt(iso, locale) {
  if (!iso) return null;

  try {
    return new Intl.DateTimeFormat(locale, {
      dateStyle: 'long',
      timeStyle: 'short',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export default function LegalDocumentView({ docKey, locale, labels }) {
  const [state, setState] = useState({ status: 'loading' });

  const loadDocument = useCallback(async () => {
    setState({ status: 'loading' });

    try {
      const doc = await fetchLegalDocument(docKey, locale);
      setState({ status: 'ready', doc });
    } catch (error) {
      setState({
        status: 'error',
        message: error instanceof Error ? error.message : labels.error,
      });
    }
  }, [docKey, locale, labels.error]);

  useEffect(() => {
    loadDocument();
  }, [loadDocument]);

  useEffect(() => {
    if (state.status !== 'ready') return;

    document.title = `${state.doc.title} | Leveltry`;

    const description = document.querySelector('meta[name="description"]');
    if (description) {
      const preview = state.doc.body.replace(/\s+/g, ' ').trim().slice(0, 160);
      description.setAttribute('content', preview);
    }
  }, [state]);

  if (state.status === 'loading') {
    return (
      <main id="contenido" className="static-page legal-page">
        <div className="shell legal-page__status">
          <p>{labels.loading}</p>
        </div>
      </main>
    );
  }

  if (state.status === 'error') {
    return (
      <main id="contenido" className="static-page legal-page">
        <div className="shell legal-page__status legal-page__status--error">
          <p>{state.message || labels.error}</p>
          <button type="button" className="btn btn-primary" onClick={loadDocument}>
            {labels.retry}
          </button>
        </div>
      </main>
    );
  }

  const updatedLabel = formatUpdatedAt(state.doc.updatedAt, locale);

  return (
    <main id="contenido" className="static-page legal-page">
      <section className="static-page__hero">
        <div className="shell static-page__hero-inner">
          <p className="eyebrow">{labels.eyebrow}</p>
          <h1>{state.doc.title}</h1>
          {updatedLabel ? (
            <p className="static-page__lead">
              {labels.updatedAt}: {updatedLabel}
            </p>
          ) : null}
        </div>
      </section>

      <section className="static-page__body">
        <div className="shell static-page__content">
          <article className="legal-document__body">{state.doc.body}</article>
        </div>
      </section>
    </main>
  );
}
